// extracted by mini-css-extract-plugin
module.exports = {"author":"PostAuthor--author--3e4LZ","profileImage":"PostAuthor--profileImage--1eCMZ"};